import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'
import { createHead } from '@vueuse/head'
import netlifyIdentity from 'netlify-identity-widget'
window.netlifyIdentity = netlifyIdentity;
netlifyIdentity.init();
const head = createHead();
const VI = createApp(App).use(router).use(head).mount('#app')